<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form :model="query" label-width="125px" inline size="mini">
      <el-form-item label="预约单号">
        <el-input v-model="query.orderUuid" clearable placeholder="请输入租赁订单号"></el-input>
      </el-form-item>
      <el-form-item label="支付订单号">
        <el-input v-model="query.payOrderUuid" clearable placeholder="请输入支付订单号"></el-input>
      </el-form-item>

      <el-form-item label="订单类型">
        <el-select v-model="query.type" clearable placeholder="请选择订单类型">
          <el-option label="无人" value="1"></el-option>
          <el-option label="滴滴" value="2"></el-option>
          <el-option label="预约" value="3"></el-option>
          <el-option label="特惠时段" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单渠道">
        <el-select v-model="query.channel" clearable placeholder="请选择订单渠道">
          <el-option label="微信" value="1"></el-option>
          <el-option label="支付宝" value="2"></el-option>
          <el-option label="微信余额" value="11"></el-option>
          <el-option label="支付宝余额" value="12"></el-option>
          <el-option label="门店余额" value="21"></el-option>
          <el-option label="美团团购" value="88"></el-option>
          <el-option label="抖音团购" value="99"></el-option>
          <el-option label="优惠券" value="66"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select v-model="query.status" clearable placeholder="请选择订单状态">
          <el-option label="使用中" value="1"></el-option>
          <el-option label="已完成" value="2"></el-option>
          <el-option label="取消" value="10"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户信息">
        <el-input v-model="query.user" clearable placeholder="请输入用户信息"></el-input>
      </el-form-item>
      <el-form-item label="房间信息">
        <el-input v-model="query.room" clearable placeholder="请输入房间信息"></el-input>
      </el-form-item>
      <el-form-item label="设备信息">
        <el-input v-model="query.equipment" clearable placeholder="请输入设备信息"></el-input>
      </el-form-item>
      <el-form-item label="商家信息">
        <el-select v-model="query.merchant" clearable filterable placeholder="请选择商家信息">
          <el-option v-for="items in merchantNames" :key="items" :label="items" :value="items"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代理信息">
        <el-select v-model="query.agent" clearable filterable placeholder="请选择代理信息">
          <el-option v-for="items in agentNames" :key="items" :label="items" :value="items"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="员工信息">
        <el-input v-model="query.staff" clearable placeholder="请输入员工信息"></el-input>
      </el-form-item>

      <el-form-item label="使用时间段">
        <el-date-picker
          v-model="ctPeriod"
          value-format="yyyy-MM-dd"
          unlink-panels
          type="daterange"
          range-separator="至"
          start-placeholder="创建起始时间"
          end-placeholder="创建结束时间"
        ></el-date-picker>
      </el-form-item>
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
      <el-button type="success" size="mini" @click="excelDetail">明细导出</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 表格数据展示区域 -->
      <el-table :data="orderList" style="width: 100%" height="650px" border="" stripe>
        <!-- 展开行区域 -->
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-width="110px" label-position="left" inline class="expand">
              <el-form-item label="用户ID">
                <span>{{ scope.row.userUuid }}</span>
              </el-form-item>
              <el-form-item label="用户昵称">
                <span>{{ scope.row.userName }}</span>
              </el-form-item>
              <el-form-item label="用户手机号">
                <span>{{ scope.row.userCellphone }}</span>
              </el-form-item>
              <el-form-item label="代理ID">
                <span>{{ scope.row.agentUuid }}</span>
              </el-form-item>
              <el-form-item label="代理昵称">
                <span>{{ scope.row.agentName }}</span>
              </el-form-item>
              <el-form-item label="代理手机号">
                <span>{{ scope.row.agentCellphone }}</span>
              </el-form-item>
              <el-form-item label="员工ID">
                <span>{{ scope.row.staffUuid }}</span>
              </el-form-item>
              <el-form-item label="员工昵称">
                <span>{{ scope.row.staffName }}</span>
              </el-form-item>
              <el-form-item label="员工手机号">
                <span>{{ scope.row.staffCellphone }}</span>
              </el-form-item>
              <el-form-item label="商家ID">
                <span>{{ scope.row.merchantUuid }}</span>
              </el-form-item>
              <el-form-item label="商家名称">
                <span>{{ scope.row.merchantName }}</span>
              </el-form-item>
              <el-form-item label="三方订单号">
                <span>{{ scope.row.tpOrderId }}</span>
              </el-form-item>
<!--              <el-form-item label="商家手机号">-->
<!--                <span>{{ scope.row.merchantCellphone }}</span>-->
<!--              </el-form-item>-->
              <el-form-item label="房间ID">
                <span>{{ scope.row.roomUuid }}</span>
              </el-form-item>
              <el-form-item label="房间名称">
                <span>{{ scope.row.roomName }}</span>
              </el-form-item>
              <el-form-item label="设备编码">
                <span>{{ scope.row.equipmentUuid }}</span>
              </el-form-item>
              <el-form-item label="开始使用时间">
                <span>{{ scope.row.startTime }}</span>
              </el-form-item>
              <el-form-item label="结束使用时间">
                <span>{{ scope.row.finishTime }}</span>
              </el-form-item>
              <el-form-item label="使用时间">
                <span>{{scope.row.useTime}}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <!-- 表格数据展示区域 -->
        <el-table-column prop="uuid" label="订单号" width="210" align="center"></el-table-column>
        <el-table-column prop="createTime" label="订单创建时间" width="140" align="center"></el-table-column>
        <el-table-column label="订单类型" width="80" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 1" type="warning">无人</el-tag>
            <el-tag v-else-if="scope.row.type === 2" type="danger">滴滴</el-tag>
            <el-tag v-else-if="scope.row.type === 3 && scope.row.tpOrderId" type="info">预订</el-tag>
            <el-tag v-else-if="scope.row.type === 3 && !scope.row.tpOrderId" type="info">预约</el-tag>
            <el-tag v-else-if="scope.row.type === 5" type="info">特惠</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0">未上电</el-tag>
            <el-tag v-else-if="scope.row.status === 1">使用中</el-tag>
            <el-tag v-else-if="scope.row.status === 2" type="success">已完成</el-tag>
            <el-tag v-else type="info">已取消</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="结算状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isSettle === 0 && scope.row.status === 0" type="info">未上电</el-tag>
            <el-tag v-else-if="scope.row.isSettle === 0 && scope.row.status === 1" type="info">使用中</el-tag>
            <el-tag v-else-if="scope.row.isSettle === 0 && scope.row.status === 10" type="info">已取消</el-tag>
            <el-tag v-else-if="scope.row.isSettle === 0" type="warning">未结算</el-tag>
            <el-tag v-else-if="scope.row.isSettle === 1" type="success">已结算</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="支付渠道" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.channel === 1">微信</span>
            <span v-else-if="scope.row.channel === 2">支付宝</span>
            <span v-else-if="scope.row.channel === 3">微信授权</span>
            <span v-else-if="scope.row.channel === 4">支付宝授权</span>
            <span v-else-if="scope.row.channel === 21">门店余额</span>
            <span v-else-if="scope.row.channel === 12">支付宝余额</span>
            <span v-else-if="scope.row.channel === 88">美团团购</span>
            <span v-else-if="scope.row.channel === 99">抖音团购</span>
            <span v-else-if="scope.row.channel === 66">优惠券</span>
            <span v-else>APP</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="支付订单号" width="220">
          <template slot-scope="scope">
            <div v-if="scope.row.payOrderUuid" class="numberingBox" @click="lookOrder(scope.row.payOrderUuid,scope.row.status)">
              <i class="el-icon-thumb"></i>
              {{scope.row.payOrderUuid}}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="支付金额/元" width="100" align="right">
          <template slot-scope="scope">
            <div v-if="scope.row.payOrderUuid" class="numberingBox" @click="lookOrder(scope.row.payOrderUuid,scope.row.status)">
              <i class="el-icon-thumb"></i>
              {{scope.row.totalAmount}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="结算/元" width="80" align="right">
          <template slot-scope="scope">
            <div class="numberingBox" style="color: #e6a23c;" @click="lookEarnings(scope.row.uuid,scope.row.status)">
              {{scope.row.settleAmount}}
              <i class="el-icon-coin" style="color: #2299DD;"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="settleTime" label="结算时间" width="140" align="center"></el-table-column>
        <!-- <el-table-column label="退款/元" width="80" align="right">
          <template slot-scope="scope">
            <div style="color: #FF6161;">{{scope.row.rollbackAmount}}</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="" label="单价" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.unitPrice }}元/{{ scope.row.priceType==1?'60分钟':scope.row.priceType==2?'30分钟':'1小时' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="useTime" label="使用时间" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" width="240" align="center"></el-table-column>
<!--        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.type===1" :disabled="scope.row.status === 1 ? false : true" type="success" size="mini" @click="completeOrder(scope.row.uuid, 0)">结算</el-button>
            <el-button v-if="scope.row.type===1" :disabled="scope.row.status === 1 ? false : true" type="danger" size="mini" @click="completeOrder(scope.row.uuid, 1)">强制结算</el-button>
            <el-button v-if="scope.row.type===2" :disabled="scope.row.status === 1 ? false : true" type="warning" size="mini" @click="cancelOrder(scope.row.uuid, 0)">取消</el-button>
            <el-button v-if="scope.row.type===2" :disabled="scope.row.status === 1 ? false : true" type="danger" size="mini" @click="cancelOrder(scope.row.uuid, 1)">强制取消</el-button>
          </template>
        </el-table-column>-->
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 支付订单详情对话框 -->
    <el-dialog title="支付订单详情" :visible.sync="orderDialogVisible" width="50%">
      <el-form label-width="86px" label-position="left" inline class="payDetails">
        <el-form-item label="支付订单号: ">
          <span>{{ orderDetails.uuid }}</span>
        </el-form-item>
        <el-form-item label="用户ID: ">
          <span>{{ orderDetails.userUuid }}</span>
        </el-form-item>
        <el-form-item label="用户昵称: ">
          <span>{{ orderDetails.userName }}</span>
        </el-form-item>
        <el-form-item label="用户手机号: ">
          <span>{{ orderDetails.userCellphone }}</span>
        </el-form-item>
        <el-form-item label="订单类型: ">
          <span v-if="orderDetails.type === 1">押金</span>
          <span v-else-if="orderDetails.type === 2">余额</span>
          <span v-else-if="orderDetails.type === 51">滴滴支付</span>
          <span v-else-if="orderDetails.type === 3">充电线租赁</span>
          <span v-else-if="orderDetails.type === 3">充电线租赁</span>
          <span v-else-if="orderDetails.type === 3">充电线租赁</span>
          <span v-else-if="orderDetails.type === 3">充电线租赁</span>
          <span v-else>租赁</span>
        </el-form-item>
        <el-form-item label="订单状态: ">
          <span v-if="orderDetails.status === 0">进行中...</span>
          <span v-else-if="orderDetails.status === 1">支付成功</span>
          <span v-else-if="orderDetails.status === 2">支付失败</span>
          <span v-else-if="orderDetails.status === 3">取消支付</span>
          <span v-else-if="orderDetails.status === 4">申请退款</span>
          <span v-else-if="orderDetails.status === 5">退款成功</span>
          <span v-else-if="orderDetails.status === 6">退款失败</span>
          <span v-else-if="orderDetails.status === 7">取消退款</span>
          <span v-else-if="orderDetails.status === 8">全额抵扣</span>
          <span v-else-if="orderDetails.status === 11">冻结成功</span>
          <span v-else-if="orderDetails.status === 12">解冻成功</span>
          <span v-else-if="orderDetails.status === 13">冻结失败</span>
          <span v-else>冻结失败</span>
        </el-form-item>
        <el-form-item label="支付渠道: ">
          <span v-if="orderDetails.channel === 1">微信支付</span>
          <span v-else-if="orderDetails.channel === 2">支付宝支付</span>
          <span v-else-if="orderDetails.channel === 3">微信支付分</span>
          <span v-else-if="orderDetails.channel === 4">支付宝预授权</span>
          <span v-else-if="orderDetails.channel === 11">微信余额</span>
          <span v-else-if="orderDetails.channel === 12">支付宝余额</span>
          <span v-else-if="orderDetails.channel === 13">APP余额</span>
          <span v-else>APP支付</span>
        </el-form-item>
        <el-form-item label="支付金额: ">
          <span>{{ orderDetails.amount }}</span>
        </el-form-item>
        <el-form-item label="支付描述: ">
          <span>{{ orderDetails.detail }}</span>
        </el-form-item>
        <el-form-item label="创建时间: ">
          <span>{{ orderDetails.createTime }}</span>
        </el-form-item>
        <el-form-item label="支付时间: ">
          <span>{{ orderDetails.payTime }}</span>
        </el-form-item>
        <el-form-item label="完成时间: ">
          <span>{{ orderDetails.finishTime }}</span>
        </el-form-item>
        <el-form-item label="流水号: ">
          <span>{{ orderDetails.transactionId }}</span>
        </el-form-item>
        <el-form-item label="是否退款: ">
          <span v-if="orderDetails.isRefund === 1">是</span>
          <span v-else>否</span>
        </el-form-item>
        <el-form-item label="使用积分: ">
          <span>{{ orderDetails.amount1 }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="orderDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 收益分配详情对话框 -->
    <el-dialog title="收益分配详情" :visible.sync="incomeDialogVisible" width="80%">
      <el-table :data="earningsDetails" style="width: 100%" stripe border="">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-position="left" inline class="expand">
              <el-form-item label="用户ID">
                <span>{{ scope.row.sourceUuid }}</span>
              </el-form-item>
              <el-form-item label="钱包ID">
                <span>{{ scope.row.walletUuid }}</span>
              </el-form-item>
              <el-form-item label="租赁订单号">
                <span>{{ scope.row.leaseOrderUuid }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="uuid" label="流水号" width="240"></el-table-column>
        <el-table-column prop="sourceType" label="用户类型">
          <template slot-scope="scope">
            <span v-if="scope.row.sourceType === '1'">普通用户</span>
            <span v-else-if="scope.row.sourceType === '11'">代理</span>
            <span v-else-if="scope.row.sourceType === '12'">员工</span>
            <span v-else-if="scope.row.sourceType === '21'">商家</span>
            <span v-else-if="scope.row.sourceType === '22'">合伙人</span>
          </template>
        </el-table-column>
        <el-table-column prop="sourceName" label="用户昵称"></el-table-column>
        <el-table-column prop="sourceCellphone" label="用户手机号"></el-table-column>
        <el-table-column prop="amount" label="收益/支出金额(元)" width="160"></el-table-column>
        <el-table-column prop="lastAmount" label="钱包余额(元)"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
        <el-table-column prop="port" label="收益类型">
          <template slot-scope="scope">
            <span v-if="scope.row.port === 1">收益</span>
            <span v-else-if="scope.row.port === -1">支出</span>
            <span v-else>空</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="302"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="incomeDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 完结订单对话框 -->
    <el-dialog title="完结订单" :visible.sync="endDialogVisible" width="30%">
      <el-form label-width="100px" label-position="left" inline>
        <el-form-item label="订单结束时间: ">
          <el-date-picker
            v-model="endOrderData.finishTime"
            size="small"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择订单结束时间"
            :default-time="nowTime"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="endCancel">取 消</el-button>
        <el-button type="primary" @click="endSubmit">完结订单</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { leaseList, payInfo, profitInfo, endOrder, cancel, excelOrder } from '@/API/order'
import { merchantNameList } from '@/API/merchant'
import { agentNameList } from '@/API/proxy'
export default {
  name: 'lease',
  data() {
    return {
      query: {
        curPage: 1,
        pageSize: 10,

        orderUuid: '',
        payOrderUuid: '',
        bEqpSn: '',
        rEqpSn: '',
        deviceSn: '',
        channel: '',
        type: '',
        status: '',
        rollback: '',

        userUuid: '',

        userCellphone: '',
        agentCellphone: '',
        merchantCellphone: '',

        user: '',
        agent: '',
        staff: '',
        merchant: ''
      },
      merchantNames: [],
      agentNames: [],
      // 开始使用时间段
      ctPeriod: [],
      // 开始使用时间段
      stPeriod: [],
      // 结束使用时间段
      ftPeriod: [],
      // 订单数据列表
      orderList: [],
      // 数据总条数
      total: 0,
      // 支付订单详情数据
      orderDetails: {},
      // 支付订单详情对话框是否显示
      orderDialogVisible: false,
      // 收益分配详情
      earningsDetails: [],
      // 收益分配详情对话框是否显示
      incomeDialogVisible: false,
      // 租赁订单详情对话框是否显示
      leaseDialogVisible: false,
      // 租赁订单详情
      leaseInfo: {},
      // 完结订单对话框
      endDialogVisible: false,
      // 完结订单数据
      endOrderData: {
        force: 0,
        finishTime: '',
        orderId: ''
      },
      nowTime: '',
      profitDialogVisible: false,
      profitData: {
        orderId: '',
        amount: '',
        password: ''
      },

      // 开始使用时间段
      dstPeriod: [],
      // 开始使用时间段
      dftPeriod: [],
      // 结束使用时间段
      dsettPeriod: '',
      ifCreate: false,
      buttonTxt: '等待生成...'
    }
  },
  created() {
    let startDate = new Date()
    startDate.setTime(startDate.getTime() - 30 * 24 * 3600 * 1000)
    this.ctPeriod[0] = startDate.getFullYear() + (startDate.getMonth() + 1 < 10 ? '-0' : '-') + (startDate.getMonth() + 1) + (startDate.getDate() < 10 ? '-0' : '-') + startDate.getDate()
    this.query.ctStart = this.ctPeriod[0]
    let endDate = new Date()
    this.ctPeriod[1] = endDate.getFullYear() + (endDate.getMonth() + 1 < 10 ? '-0' : '-') + (endDate.getMonth() + 1) + (endDate.getDate() < 10 ? '-0' : '-') + endDate.getDate()
    this.query.ctEnd = this.ctPeriod[1]

    this.getOrderList()
    this.getSelectData()
  },
  methods: {
    async getOrderList() {
      const { data: res } = await leaseList(this.query)
      if (res.code !== 200) return this.message.error(res.message)
      this.orderList = res.data.entities
      this.total = res.data.totalSize
    },
    async getSelectData() {
      const { data: res } = await merchantNameList({})
      if (res.code !== 200) return this.message.error(res.message)
      this.merchantNames = res.data

      const { data: res2 } = await agentNameList({})
      if (res2.code !== 200) return this.message.error(res.message)
      this.agentNames = res2.data
    },
    // 重置按钮点击事件
    custody() {
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.ctPeriod = []
      this.stPeriod = []
      this.ftPeriod = []
      this.getOrderList()
    },
    // 搜索按钮点击事件
    seach() {
      this.query.curPage = 1
      if (this.ctPeriod != null) {
        this.query.ctStart = this.ctPeriod[0]
        this.query.ctEnd = this.ctPeriod[1]
      } else {
        this.query.ctStart = ''
        this.query.ctEnd = ''
      }
      if (this.stPeriod != null) {
        this.query.stStart = this.stPeriod[0]
        this.query.stEnd = this.stPeriod[1]
      } else {
        this.query.stStart = ''
        this.query.stEnd = ''
      }
      if (this.ftPeriod != null) {
        this.query.ftStart = this.ftPeriod[0]
        this.query.ftEnd = this.ftPeriod[1]
      } else {
        this.query.ftStart = ''
        this.query.ftEnd = ''
      }
      this.getOrderList()
    },
    // 监听pageSize
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getOrderList()
    },
    // 监听curPage
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.getOrderList()
    },
    // 获取支付订单详情
    async getOrderDetails(orderUuid) {
      const { data: res } = await payInfo({
        orderUuid,
        curPage: 1,
        pageSize: 1
      })
      if (res.code !== 200) return this.$message.error(res.message)
      this.orderDetails = res.data.entities[0]
    },
    // 查看支付订单详情
    lookOrder(orderUuid, status) {
      // if (status === 3 || status === 10) return
      this.getOrderDetails(orderUuid)
      this.orderDialogVisible = true
    },
    // 查看收益分配
    async lookEarnings(orderUuid, status) {
      // if (status !== 2 && status !== 4) return
      const { data: res } = await profitInfo({ orderUuid })
      if (res.code !== 200) return this.$message.error(res.message)
      this.earningsDetails = res.data
      this.incomeDialogVisible = true
    },
    // 完结订单
    completeOrder(orderId, force) {
      this.endOrderData.orderId = orderId
      this.endOrderData.force = force
      this.endDialogVisible = true
      this.nowTime = (new Date().getHours() + '').padStart(2, '0') + ':' + (new Date().getMinutes() + '').padStart(2, '0') + ':00'
    },
    // 提交完结订单
    async endSubmit() {
      if (this.endOrderData.finishTime === '') return this.$message.info('请选择订单结束时间')
      const { data: res } = await endOrder(this.endOrderData)
      if (res.code !== 200) return this.$message.error(res.message)
      this.$message.success(res.message)
      this.getOrderList()
      this.endDialogVisible = false
      this.endOrderData = {}
    },
    // 取消完结订单对话框
    endCancel() {
      this.endDialogVisible = false
      this.endOrderData = {}
    },
    cancelOrder(orderId, force) {
      let str = '正常'
      if (force === 1) str = '强制'
      this.$confirm('此操作将' + str + '取消订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await cancel({
          orderId: orderId,
          force: force
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.getOrderList()
      })
    },
    // 明细导出
    async excelDetail() {
      if (this.ctPeriod.length === 0) return this.$message.error('请选择导出的明细日期')
      const { data: res } = await excelOrder(this.query).catch(err => {
        if (err.response) {
          if (err.response.status === 701) {
            return this.$message.error('请筛选后再导出')
          } else if (err.response.status === 702) {
            return this.$message.error('无筛选记录')
          }
        }
        return this.$message.error('系统繁忙，请稍候再试')
      })
      if (!res) {
        return
      }
      let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', '租赁订单明细-' + new Date().getTime() + '.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style lang="less" scoped>
.custodyByn {
  margin-left: 38px;
}
.expand {
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 33%;
  }
}
.numberingBox {
  cursor: pointer;
}
.el-pagination {
  margin-top: 30px;
}
.payDetails {
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
}
</style>
<style lang="less">
.expand label,
.payDetails label {
  color: #99a9bf;
}
</style>
